"use client"

import type { AtomizedDrop } from "@anaconda/core/drop/utils"
import type { CollectionId } from "@anaconda/core/nft-collection/types"
import type { Atom } from "@reatom/core"
import { reatomComponent } from "@reatom/react"
import { ScopeProvider } from "bunshi/react"
import { useMemo } from "react"
import { DropIdScope, DropScope, RefetchIntervalScope } from "./scope"

interface Props {
  children: React.ReactNode
  dropId: CollectionId
  dropAtom: Atom<AtomizedDrop>
  refetchIntervalMs?: number
}

export const DropScopeProvider = reatomComponent((props: Props) => {
  const dropId = props.dropAtom().id()
  const dropIdObj = useMemo(() => ({ dropId }), [dropId])
  return (
    <ScopeProvider scope={DropIdScope} value={dropIdObj}>
      <ScopeProvider scope={DropScope} value={props.dropAtom}>
        <ScopeProvider
          scope={RefetchIntervalScope}
          value={props.refetchIntervalMs ?? 5000}
        >
          {props.children}
        </ScopeProvider>
      </ScopeProvider>
    </ScopeProvider>
  )
})
